import React, { useEffect, useState } from "react";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CardBody, Row, Col, Card, CardHeader, Modal, ModalHeader, ModalBody, Spinner, Button, Input } from "reactstrap";
import TableContainer from "../../Components/Common/TableContainer";
import Loader from "../../Components/Common/Loader";
import DeleteModal from "../../Components/Common/DeleteModal";
import { handleSpaceKeyPress } from "../../common/spacePrevent";
import { addTone, getTone, updateStatusTone, UpdateTone } from "../../slices/toneManagement";
import { toast } from "react-toastify";
import moment from "moment";

const customerstatus = [
  { label: "All", value: "" },
  { label: "Active", value: "active" },
  { label: "Deactivate", value: "inactive" },
];
const ToneManagement = () => {
  document.title = "Tone Management | WriterTools";

  const dispatch = useDispatch();
  const { toneCount, toneData, toneLoader } = useSelector((state) => state.ToneManagement);
  const [customerStatus, setcustomerStatus] = useState(customerstatus[0]);
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(1);
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [rowId, setRowId] = useState("");
  const [limit, setLimit] = useState(10);
  const [userStatus, setuserStatus] = useState({});
  const [loader, setLoader] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const nPages = Math.ceil(toneCount / limit);

  const handleOnChangeLimit = (value) => {
    setPage(1);
    setLimit(value);
  };

  const handleOnChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  useEffect(() => {
    setPage(1);
  }, [searchValue, customerStatus]);

  useEffect(() => {
    setSearchValue("");
  }, [customerStatus]);

  useEffect(() => {
    const params = {};
    if (customerStatus?.value && customerStatus?.value !== "All") {
      params.isActive = customerStatus.value === "active" ? true : false;
    }
    if (searchValue) {
      params.search = searchValue?.trimEnd();
    }
    if (page) {
      params.page = page;
    }
    if (limit) {
      params.limit = limit;
    }
    if (searchValue) {
      let timer;
      const makeAPICall = () => {
        dispatch(
          getTone({
            ...params,
          })
        );
      };
      clearTimeout(timer);
      timer = setTimeout(makeAPICall, 1000);
      return () => clearTimeout(timer);
    } else {
      dispatch(
        getTone({
          ...params,
        })
      );
    }
  }, [customerStatus, searchValue, page, limit]);

  const handleValidDate = (date) => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };

  const onClickOpenAddModal = () => {
    setAddModal(true);
    setRowId("");
  };

  const deleteTone = (status) => {
    const data1 = {
      id: status?._id,
      status: status?.isActive,
    };

    setuserStatus(data1);
    setDeleteModal(true);
  };

  const columns = useMemo(() => [
    {
      Header: "Sr. no",
      accessor: "srno",
      id: "index",
      Cell: (row) => {
        return (
          <>
            <div className="w-sm">{(page - 1) * 10 + row.row.index + 1}</div>
          </>
        );
      },
    },
    {
      Header: "Created Date",
      Cell: (cellProps) => <>{handleValidDate(cellProps?.row?.original?.createdAt)}</>,
    },
    {
      Header: "Tone Name",
      accessor: (row) => row?.tone ?? "-",

      filterable: false,
    },
    {
      Header: "Tone Description",
      accessor: (row) => row?.description ?? "-",

      filterable: false,
    },
    {
      Header: "Status",
      accessor: "isActive",
      Cell: (cellProps) => {
        switch (cellProps?.row?.original.isActive) {
          case true:
            return <span className="badge text-uppercase badge-soft-success">Active</span>;
          case false:
            return <span className="badge text-uppercase badge-soft-danger">Deactive</span>;
          default:
            return <span className="badge text-uppercase badge-soft-info">Unknown</span>;
        }
      },
    },
    {
      Header: "Action",
      Cell: (cellProps) => {
        return (
          <div className="d-flex " style={{ width: "100px" }}>
            <span style={{ cursor: "pointer" }}>
              <i
                className="ri-pencil-fill align-bottom me-2 text-muted "
                style={{ fontSize: "21px" }}
                onClick={() => {
                  handleOnEdit(cellProps?.row?.original);
                }}
              ></i>
            </span>

            <Button
              className="btn-sm"
              style={{ paddingY: "0px", margin: "0px" }}
              color={cellProps?.row?.original.isActive === true ? "danger" : "success"}
              onClick={() => {
                deleteTone(cellProps?.row?.original);
              }}
            >
              {cellProps?.row?.original.isActive === true ? "Deactivate" : "Activate"}
            </Button>
          </div>
        );
      },
    },
  ]);

  const handleDeleteCategory = () => {
    setLoader(true);
    dispatch(updateStatusTone({ id: userStatus?.id, isActive: !userStatus?.status }))
      .then((res) => {
        if (res?.payload.success === true) {
          if (userStatus?.status !== "active") {
            toast.success("Deactive successfully");
          } else {
            toast.success("Active successfully");
          }
          setDeleteModal(false);
          setLoader(false);
          dispatch(
            getTone({
              page: page,
              limit: limit,
              isActive: customerStatus?.value ? customerStatus?.value : null,
              search: searchValue?.trimEnd() ? searchValue?.trimEnd() : null,
            })
          );
        } else {
          setLoader(false);
          toast.error(res?.payload?.data?.message);
        }
      })
      .catch((err) => {
        setLoader(false);
        toast.error(err?.data?.message);
      });
  };

  const formValidation = () => {
    let isFormValid = true;
    let newErrors = {};
    const requiredFields = ["toneName", "description"];
    requiredFields.forEach((field) => {
      if (!values?.toneName || values?.toneName.trim() === "") {
        isFormValid = false;
        newErrors["toneName"] = "Please enter a valid tone name";
      }
      if (!values?.description || values?.description.trim() === "") {
        isFormValid = false;
        newErrors["description"] = "Please enter a valid description";
      }
    });

    setErrors(newErrors);
    return isFormValid;
  };

  const handleOnEdit = (item) => {
    setRowId(item?._id);
    setValues({
      ...values,
      toneName: item?.tone,
      description: item?.description,
    });
    setAddModal(true);
  };

  const handleOnAddTone = () => {
    if (formValidation()) {
      setLoader(true);
      let body = {
        tone: values?.toneName,
        description: values?.description,
      };
      dispatch(addTone(body))
        .then((res) => {
          if (res?.payload?.success) {
            setValues({});
            setAddModal(false);
            dispatch(getTone({ page: page, limit: limit }));
            setLoader(false);
            toast.success("Tone added successfully");
          } else {
            setLoader(false);
            toast.error(res?.payload?.data?.message);
          }
        })
        .catch((err) => {
          setLoader(false);
          toast.error(err.response.data.message);
        });
    }
  };

  const handleOnUpdateTone = () => {
    if (formValidation()) {
      setLoader(true);
      let body = {
        tone: values?.toneName,
        description: values?.description,
        id: rowId,
      };
      dispatch(UpdateTone(body))
        .then((res) => {
          if (res?.payload?.success) {
            setAddModal(false);
            setLoader(false);
            setValues({});
            dispatch(getTone({ page: page, limit: limit }));
            toast.success("Category Updated Successfully");
          } else {
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          toast.error(err.response.data.message);
        });
    }
  };
  return (
    <>
      <Modal isOpen={addModal} centered id="exampleModal">
        <ModalHeader
          toggle={() => {
            setAddModal(false);
            setValues({});
            setErrors({});
          }}
        >
          {rowId ? "Update Tone" : "Add Tone"}{" "}
        </ModalHeader>
        <ModalBody>
          <form>
            <div className="mb-3">
              <label htmlFor="customer-name" className="col-form-label">
                Tone Name:
                <span className="text-danger">*</span>
                {errors.toneName && <span className="text-danger">{errors.toneName}</span>}
              </label>
              <Input
                type="text"
                className="form-control"
                id="customer-name"
                name="toneName"
                placeholder="Enter tone name"
                value={values.toneName}
                onChange={handleOnChange}
                onKeyDown={handleSpaceKeyPress}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="message-text" className="col-form-label">
                Tone Description: <span className="text-danger">*</span>
                {errors.description && <span className="text-danger">{errors.description}</span>}
              </label>
              <textarea
                className="form-control"
                id="message-text"
                rows="4"
                name="description"
                placeholder="Enter category description"
                value={values.description}
                onChange={handleOnChange}
                onKeyDown={handleSpaceKeyPress}
              ></textarea>
            </div>
          </form>
        </ModalBody>
        <div className="modal-footer">
          <Button
            color="light"
            onClick={() => {
              setAddModal(false);
              setValues({});
              setErrors({});
            }}
          >
            Close
          </Button>
          <Button
            color="primary"
            onClick={() => {
              rowId ? handleOnUpdateTone() : handleOnAddTone();
            }}
          >
            {loader && (
              <Spinner size="sm" className="flex-shrink-0  ">
                {" "}
                Loading...{" "}
              </Spinner>
            )}
            <span className="flex-grow-1 ms-2">{rowId ? "Update Tone" : "Add Tone"}</span>
          </Button>
        </div>
      </Modal>

      <div className="page-content">
        <DeleteModal
          show={deleteModal}
          text={userStatus?.status == true ? "Deactivate" : "Activate"}
          onDeleteClick={() => handleDeleteCategory()}
          onCloseClick={() => setDeleteModal(false)}
          loader={loader}
        />
        <Row>
          <Col lg={12}>
            <Card id="invoiceList">
              <CardHeader className="border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">Add Tone</h5>
                  {toneCount > 10 && (
                    <div className="flex-shrink-0">
                      <div className="d-flex gap-2 flex-wrap">
                        Show
                        <select
                          name="pagination"
                          style={{ width: "70px" }}
                          value={limit}
                          onChange={(e) => handleOnChangeLimit(Number(e.target.value))}
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                        entries
                      </div>
                    </div>
                  )}
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  {toneLoader ? (
                    <>
                      <Loader />
                    </>
                  ) : (
                    <>
                      {toneData && toneData.length > 0 ? (
                        <TableContainer
                          columns={columns || []}
                          data={toneData || []}
                          isGlobalFilter={true}
                          isAddUserList={false}
                          customPageSize={limit}
                          isCustomerFilter={true}
                          customerstatus={customerstatus}
                          setcustomerStatus={setcustomerStatus}
                          customerStatus={customerStatus}
                          divClass="table-responsive mb-1"
                          tableClass="mb-0 align-middle table-border"
                          theadClass="table-light text-muted"
                          SearchPlaceholder="Search Tone..."
                          setSearchValue={setSearchValue}
                          searchValue={searchValue}
                          isPagination={toneCount > 10 ? true : false}
                          nPages={nPages}
                          currentPage={page}
                          setCurrentPage={setPage}
                          iscreated={true}
                          addbuttontext={"Add Tone"}
                          onClickOpenAddModal={onClickOpenAddModal}
                          totalDataCount={toneCount}
                          ispaginationshow={toneCount > 10 && limit < toneCount ? true : false}
                        />
                      ) : (
                        <>
                          <TableContainer
                            columns={[]}
                            data={[]}
                            isGlobalFilter={true}
                            isCustomerFilter={true}
                            customPageSize={0}
                            customerstatus={customerstatus}
                            setcustomerStatus={setcustomerStatus}
                            customerStatus={customerStatus}
                            tableClass="mb-0 align-middle table-border"
                            theadClass="table-light text-muted"
                            SearchPlaceholder="Search Tone..."
                            setSearchValue={setSearchValue}
                            searchValue={searchValue}
                            isPagination={false}
                            iscreated={true}
                            addbuttontext={"Add Tone"}
                            onClickOpenAddModal={onClickOpenAddModal}
                          />
                        </>
                      )}
                    </>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ToneManagement;
